import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { PanelService } from 'src/app/services/panel.service';

@Component({
  selector: 'app-dialog-subscribe-office',
  templateUrl: './dialog-subscribe-office.component.html',
  styleUrls: ['./dialog-subscribe-office.component.scss'],
})
export class DialogSubscribeOffice implements OnInit {
  @Input() value: any;
  @Output() onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  allRegions: { id: number; region: string; year: string }[] = [];
  allSubRegions: { id: number; region: string; year: string }[] = [];
  selectedRegion: { id: number; region: string; year: string } = {
    id: 0,
    year: '',
    region: '',
  };
  selectedSubregion: { id: number; region: string; year: string } = {
    id: 0,
    year: '',
    region: '',
  };
  loading: boolean = true;

  constructor(private readonly panelService: PanelService) {}

  ngOnInit() {
    this.getRegion();
    this.onChange.emit(true);
  }

  getRegion() {
    this.panelService.getAdvancedSearchRegions().then(
      async (res: any) => {
        if (res?.data) {
          this.allRegions = res.data;
          const AUX = this.allRegions.find(
            (regions: { id: number }) => regions.id == this.value.regionId
          );
          if(AUX) this.selectedRegion = AUX;

          this.setSubregions(this.value.regionId);
        }
      },
      (error: Error) => {
        console.log(error);
      }
    );
  }
  async getSubregion(event: number) {
    let fullSubregion;
    if (this.allSubRegions) {
       fullSubregion = this.allSubRegions.find(
        (e: { id: number }) => e.id == event
      );
    }
    return fullSubregion;
  }

  setSubregions(regionId: number) {
    this.allSubRegions = [];
    this.panelService.getAdvancedSearchSubRegions(regionId).then(
      async (res: any) => {
        if (res?.data) {
          this.allSubRegions = await res.data;

          if (this.selectedRegion) {
            const aux = await this.getSubregion(this.value.subregionId);
            if(aux) this.selectedSubregion = aux;
          }
          this.loading = false;
        }
      },
      (error: Error) => {
        console.log(error);
      }
    );

  }
}
